/**
 * services/queue/health.ts
 * Probes sk-queue-api's unversioned /health (no auth, no DB round-trip). Used to
 * decide whether the live API is reachable so the app can surface its data
 * source. Short timeout + never throws — a down/absent backend just resolves false.
 */

import axios from 'axios';
import { QUEUE_HEALTH_URL } from '../../api/config';

export interface HealthResult {
  reachable: boolean;
  url: string;
  detail?: string;
}

export async function probeQueueApi(timeoutMs = 2500): Promise<HealthResult> {
  try {
    const res = await axios.get(QUEUE_HEALTH_URL, { timeout: timeoutMs });
    return { reachable: res.status >= 200 && res.status < 300, url: QUEUE_HEALTH_URL };
  } catch (e: any) {
    return { reachable: false, url: QUEUE_HEALTH_URL, detail: e?.message ?? 'unreachable' };
  }
}
